__turbopack_context__.v({
  "body": "styles-module-scss-module__Rs2WlW__body",
  "buttons-container": "styles-module-scss-module__Rs2WlW__buttons-container",
  "container": "styles-module-scss-module__Rs2WlW__container",
  "header": "styles-module-scss-module__Rs2WlW__header",
  "left-right-container": "styles-module-scss-module__Rs2WlW__left-right-container",
  "left-side": "styles-module-scss-module__Rs2WlW__left-side",
  "mobile-header": "styles-module-scss-module__Rs2WlW__mobile-header",
  "right-side": "styles-module-scss-module__Rs2WlW__right-side",
});
